import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Alert } from '../../../common/Alert'
import { UseInput } from '../../../common/UseInput'
import {
	DIMENSION_UNIT_SELECT_ITEMS,
	LANGUAGES,
	MILESTONES,
	USER_TYPES,
	WEIGHT_UNIT_SELECT_ITEMS,
	PAGE_PRIMARY_CATEGORY,
	PAGE_SUB_CATEGORY1,
} from '../../../constants'
import { COUNTRY_CODES } from '../../../constants/countryCodes'
import { COUNTRY_DATA } from '../../../constants/countryData'
import { createUser, saveNotificationSubscription } from '../../../services/userProfileService'
import LoadingIndicator from '../../LoadingIndicator'
import { sort } from '../../../utils/common'
import CountryCodeDropdown from '../CountryCodeDropdown/index'
import {
	addAllNotifications,
	getLoggedInUserProfile,
	handleMilestone,
	validateCreateUserEmailAddress,
	validateName,
	validateUserId,
	getPrivileges,
	validateMobileCountryCode,
	validateMobileNumber,
	validatePhoneCountryCode,
	validatePhoneNumber,
	getRoles,
	validateStationCode,
} from '../userManagementUtil'
import { useTranslation } from 'react-i18next'
import Messages from '../../../constants/Messages'
import { MULTILANGUAGE_SUPPORT_ENABLED } from '../../../configs/featureControlConfig'
import { addError, pushPageData } from '../../../utils/analytics'
import pageNames from '../../../constants/pageNames'
import getPrincipal from '../../../utils/getPrincipal'
import getCurrentUser from '../../../utils/getCurrentUser'
import { getFromLocalStorage } from '../../../utils/StorageUtils'
import CommonInput from '../../../common/Resusable/CommonInput'
import { Dropdown } from 'primereact/dropdown'
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'
import { PrimaryButton, SecondaryButton } from '../../../common/Buttons'
import { AUTOCOMPLETE_TYPE, FORM_FIELDS } from '../../../constants'
import AirportAutocomplete from '../../AirportAutocomplete'
import {
	getAirportsByCode,
} from "../../../services/searchPanelServices";
import MESSAGES from '../../../constants/Messages'



const CreateUserForm = ({
	setAddUser,
	setAddUserSuccess,
	addUserSuccess,
	agentCode,
	stationCode,
	defaultAirportCode,
	listUsers,
	isGsaUser,
	customerCode,
	companyName,
	companyCode,
}) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';

	const currUserDetails = getCurrentUser();
	const {
		value: userId,
		bind: bindUserId,
		reset: resetUserId,
	} = UseInput('', { noSpaceValidation: true, upperCase: true })

	const currStationCode = stationCode && stationCode !== "" ? stationCode : (currUserDetails && currUserDetails.stationCode && currUserDetails.stationCode !== "" ? currUserDetails.stationCode : "");
	const {
		value: newStationCode,
		bind: bindNewStationCode,
		reset: resetStationCode,
	} = UseInput(currStationCode, { noSpaceValidation: true, upperCase: true })
	const {
		value: firstName,
		bind: bindFirstName,
		reset: resetFirstName,
	} = UseInput('', { noSpaceValidation: true })
	const {
		value: lastName,
		bind: bindLastName,
		reset: resetLastName,
	} = UseInput('', { noSpaceValidation: true })
	const {
		value: emailAddress,
		bind: bindEmailAddress,
		reset: resetEmailAddress,
	} = UseInput('')
	const {
		value: confirmEmailAddress,
		bind: bindConfirmEmailAddress,
		reset: resetConfirmEmailAddress,
	} = UseInput('')
	const {
		value: phoneNumber,
		bind: bindPhoneNumber,
		reset: resetPhoneNumber,
	} = UseInput('', { noSpaceValidation: true })
	const {
		value: mobileNumber,
		bind: bindMobileNumber,
		reset: resetMobileNumber,
	} = UseInput('', { noSpaceValidation: true })
	const {
		value: defaultAirportInput,
		bind: bindDefaultAirportInput,
		reset: resetDefaultAirportInput,
	} = UseInput('', { noSpaceValidation: true, upperCase: true }); // was using defaultAirportCode / currStationCode

	// REPLACE selectedAirportCode and selectedOrigin initial states:
	const [selectedAirportCode, setSelectedAirportCode] = useState(''); // was defaultAirportCode or station
	const [selectedOrigin, setSelectedOrigin] = useState(null);

	const [userType, setUserType] = useState('EU')
	const [userTypeKey, setUserTypeKey] = useState('EU')
	const [userRoleGroup, setUserRoleGroup] = useState('PORADMUSR')
	const [milestones, setMilestones] = useState({
		milestone1: false,
		milestone2: false,
		milestone3: false,
		milestone4: false,
		milestone5: false,
		milestone6: false,
	})
	const [isInitialized, setIsInitialized] = useState(false);
	const [notifications, setNotifications] = useState([

	])
	const [phContryCode, setPhContryCode] = useState('')
	const [mobContryCode, setMobContryCode] = useState('')
	// const [mobContryCode, setMobContryCode] = useState(null);

	const [userCountryCode, setCountryCode] = useState(null);

	const [bookingPrevilege, setBookingPrevilege] = useState(userTypeKey === 'KU')
	const [capturePrevilege, setCapturePrevilege] = useState(userTypeKey === 'KU')
	const [dashboardPrevilege, setDashboardPrevilege] = useState(userTypeKey === 'KU')
	const [informaticsPrevilege, setInformaticsPrevilege] = useState(userTypeKey === 'KU')
	const [allotmentPrevilege, setAllotmentPrevilege] = useState(userTypeKey === 'KU')

	const [preferences, setPreferences] = useState({
		weightUnit: 'K',
		dimensionUnit: 'C',
		language: i18n.language === 'zh' ? 'zh_CN' : 'en_US',
	})

	const [privilegeToDisable, setPrivilegeTodisable] = useState(false)

	const [isEnterpriseUser, setIsEnterpriseUser] = useState(null)

	const [error, setError] = useState(null)
	const [isLoading, setIsLoading] = useState(false)

	const [alertMessage, setAlertMessage] = useState('')
	const [createSuccess, setCreateSuccess] = useState(false)

	const [sotedCountryCodes, setSotedCountryCodes] = useState([])

	const [isStationCodeDisabled, setIsStationCodeDisabled] = useState(currStationCode !== null && currStationCode !== "");

	// Sync internal airport code when typing
	useEffect(() => {
		setSelectedAirportCode(defaultAirportInput)
	}, [defaultAirportInput])

	const validateForm = async () => {
		const fNameValid = validateName(
			firstName,
			'firstName',
			setError,
			error
		)
		const lNameValid = validateName(lastName, 'lastName', setError, error)
		const userIdValid = validateUserId(userId, setError, error)
		const emailValid = validateCreateUserEmailAddress(
			emailAddress,
			// confirmEmailAddress,
			setError,
			error
		)
		const phNoValid = validatePhoneNumber(
			phoneNumber,
			phContryCode,
			setError,
			error
		)
		const mobNoValid = validateMobileNumber(
			mobileNumber,
			mobContryCode,
			setError,
			error
		)
		const phnCountryCodeValid = validatePhoneCountryCode(
			phContryCode,
			phoneNumber,
			setError
		)
		const mobCountryCodeValid = validateMobileCountryCode(
			mobContryCode,
			mobileNumber,
			setError
		)

		const airportValid = (() => {
			const code = (selectedAirportCode || '').trim();
			if (!code) {
				setError(prev => ({ ...(prev || {}), defaultAirportCode: MESSAGES.INVALID_AIRPORT_CODE }));
				return false;
			}
			const ok = validateStationCode(code, setError, 'defaultAirportCode');
			if (!ok) {
				setError(prev => ({ ...(prev || {}), defaultAirportCode: MESSAGES.INVALID_AIRPORT_CODE }));
			}
			return ok;
		})();
		if (
			fNameValid &&
			lNameValid &&
			userIdValid &&
			emailValid &&
			phNoValid &&
			phnCountryCodeValid &&
			mobCountryCodeValid &&
			mobNoValid &&
			airportValid
		) {
			console.log('no error')
			sendRequest()
		} else {
			console.log('has error')
		}
	}



	useEffect(() => {
		const sorted = [...COUNTRY_DATA].sort((a, b) => a.code.localeCompare(b.code));
		setSotedCountryCodes(sorted);

		pushPageData(
			pageNames.USER_CREATION,
			PAGE_PRIMARY_CATEGORY.USER_PROFILE,
			PAGE_SUB_CATEGORY1.USER_MANAGEMENT
		)
		const isEnterpriseUser = getFromLocalStorage('SSOType') === 'E' ? true : false
		setIsEnterpriseUser(isEnterpriseUser)
		if (isEnterpriseUser) {
			resetStationCode();
			setIsStationCodeDisabled(false);
		}
		const defaultAirportFromSession = defaultAirportCode || (currUserDetails && currUserDetails.defaultAirportCode && currUserDetails.defaultAirportCode !== "" ? currUserDetails.defaultAirportCode : "")
		if (defaultAirportFromSession && defaultAirportFromSession.trim().length === 3) {
			getAirportsByCode(defaultAirportFromSession.trim())
				.then((airportData) => {
					if (airportData && airportData.code) {
						setSelectedOrigin(airportData);
						setSelectedAirportCode(airportData.code);
						resetDefaultAirportInput(airportData.code);
					}
				})
				.catch((err) => {

				});
		}
	}, [])

	const sendRequest = async () => {
		if (error != null) {
			setIsLoading(true)
			const responseData = await createUser(getRequest())
				.then((response) => {
					setIsLoading(false)
					if (
						response.errorDetails !== undefined &&
						response.errorDetails !== null &&
						response.errorDetails.length > 0
					) {
						const hasOktaError = response.errorDetails.some(
							error => error.errorCode === 'adm.user.okta.existinothersystem' ||
								error.errorCode === 'admin.user.duplicateuser'
						);
						if (hasOktaError) {
							addError(
								Messages.USER_EXISTS_OTHER_SYSTEM,
								i18n.getResource('en', 'errors', Messages.USER_EXISTS_OTHER_SYSTEM)
							)
							setAlertMessage(`${Messages.USER_EXISTS_OTHER_SYSTEM}`)
						} else {
							addError(
								Messages.USER_CREATION_FAILED,
								i18n.getResource('en', 'errors', Messages.USER_CREATION_FAILED)
							)
							setAlertMessage(`${Messages.USER_CREATION_FAILED}`)
						}
						setCreateSuccess(false)
						window.scrollTo(0, 0)
						return null
					} else {
						return response
					}
				})
				.catch((error) => {
					setIsLoading(false)
					addError(
						Messages.USER_CREATION_FAILED,
						i18n.getResource('en', 'errors', Messages.USER_CREATION_FAILED)
					)
					setAlertMessage(Messages.USER_CREATION_FAILED)
					setCreateSuccess(false)
					return null;
				})

			if (responseData) {
				let saveNotifStatus = true
				const areAnyChecked = notifications.length != 0;
				try {
					const saveNotifResp = await saveNotificationSubscription(getNotificationSubscribeRequest())
					if (saveNotifResp && saveNotifResp?.status === 'F') {
						saveNotifStatus = false
					}
				} catch (error) {
					saveNotifStatus = false
				}
				setAddUser(false)

				setAddUserSuccess({
					...addUserSuccess,
					success: true,
					message: Messages.USER_CREATION_SUCCESS,
					saveNotifConfig: saveNotifStatus,
					saveNotifMessage: !saveNotifStatus && areAnyChecked ? Messages.USER_PROFILE_SAVE_NOTIFICATION_FAILED : ''
				})

				if (listUsers) {
					listUsers();
				}
				window.scrollTo(0, 0)
			}
		}
	}


	useEffect(() => {
		if (!isInitialized) {
			setIsInitialized(true);
			return;
		}

		if (notifications) {
			if (addAllNotifications(notifications)) {
				setMilestones((prevState) => ({
					...prevState,
					milestone1: true,

				}))

			} else {

				setMilestones((prevState) => ({
					...prevState,
					milestone1: false,

				}))

			}
		}
	}, [notifications])

	const handleSubmit = (evt) => {
		evt.preventDefault()
		validateForm()
	}

	const onChangeUserType = (event) => {
		setUserType(event.target.value)
		if (event.target.value === 'KU') {
			setUserRoleGroup('PORADMUSR')
			setUserTypeKey('KU')
			setBookingPrevilege(true)
			setCapturePrevilege(true)
			setDashboardPrevilege(true)
			setInformaticsPrevilege(true)
			setAllotmentPrevilege(true)
		} else {
			setUserRoleGroup('PORBKGUSR')
			setUserTypeKey('EU')
			setBookingPrevilege(false)
			setCapturePrevilege(false)
			setDashboardPrevilege(false)
			setInformaticsPrevilege(false)
			setAllotmentPrevilege(false)
		}
	}

	const onChangePhCountryCode = (selectedItem) => {
		setPhContryCode(selectedItem.code);
	}

	const onChangeMobCountryCode = (selectedItem) => {
		setMobContryCode(selectedItem.code);
	}

	const handleChangeMilestone = (event) => {
		if (event.target.id === 'milestone1') {
			MILESTONES.map((milestone) => {
				setMilestones((prevState) => ({
					...prevState,
					[milestone.id]: true,
				}))
			})
		}
		handleMilestone(event, notifications, setNotifications, setMilestones)
	}

	const handleChangePrevilege = (event) => {
		const key = event.target.id
		const isChecked = event.target.checked
		if (key === 'previlege0') {
			if (isChecked) {
				setBookingPrevilege(true)
				setCapturePrevilege(true)
				setDashboardPrevilege(true)
				setInformaticsPrevilege(true)
				setAllotmentPrevilege(true)
			} else {
				setBookingPrevilege(false)
				setCapturePrevilege(false)
				setDashboardPrevilege(false)
				setInformaticsPrevilege(false)
				setAllotmentPrevilege(false)
			}
		} else if (key === 'previlege1') {
			if (isChecked) {
				setBookingPrevilege(true)
			} else {
				return setBookingPrevilege(false)
			}
		} else if (key === 'previlege2') {
			if (isChecked) {
				setCapturePrevilege(true)
			} else {
				return setCapturePrevilege(false)
			}
		} else if (key === 'previlege3') {
			if (isChecked) {
				setDashboardPrevilege(true)
			} else {
				setDashboardPrevilege(false)
				setInformaticsPrevilege(false)
				setAllotmentPrevilege(false)
			}
		} else if (key === 'previlege4') {
			if (isChecked) {
				setInformaticsPrevilege(true)
			} else {
				return setInformaticsPrevilege(false)
			}
		} else {
			if (isChecked) {
				setAllotmentPrevilege(true)
			} else {
				setAllotmentPrevilege(false)
			}
		}
	}

	const getRequest = () => {
		const loggedInUserProfile = getLoggedInUserProfile()
		const loggedInUserStation = loggedInUserProfile && loggedInUserProfile?.stationCode ? loggedInUserProfile?.stationCode : selectedAirportCode;

		const privilegeDetails = {
			bookingPrivilege: bookingPrevilege,
			capturePrivilege: capturePrevilege,
			dashBoardPrivilege: dashboardPrevilege,
			informaticsPrivilege: informaticsPrevilege,
			allotmentPrivilege: allotmentPrevilege,
		}
		const roles = getRoles(privilegeDetails)
		const requestBody = {
			requestId: Math.floor(Math.random() * 89999 + 10000),
			userDetails: {
				userId,
				firstName,
				middleName: null,
				lastName,
				email: emailAddress,
				telephoneNo:
					phContryCode !== '' && phoneNumber !== ''
						? `${phContryCode} ${phoneNumber}`
						: null,
				mobileNo:
					mobContryCode !== '' && mobileNumber !== ''
						? `${mobContryCode} ${mobileNumber}`
						: null,
				userType: userTypeKey,
				//roleGroup: userRoleGroup,
				//agentCode: loggedInUserProfile.agentCode,
				agentCode: agentCode,

				customerCode: isEnterpriseUser || isGsaUser ? (customerCode ? customerCode : null) : (loggedInUserProfile?.customerCode ? loggedInUserProfile.customerCode : null),
				companyName: isEnterpriseUser || isGsaUser ? (companyName ? companyName : null) : (loggedInUserProfile?.companyName ? loggedInUserProfile.companyName : null),
				companyCode: isEnterpriseUser || isGsaUser ? (companyCode ? companyCode : null) : (loggedInUserProfile?.companyCode ? loggedInUserProfile.companyCode : null),
				address: null,
				city: null,
				state: null,
				country: null,
				postalCode: null,
				stationCode: isEnterpriseUser || isGsaUser ? (stationCode ? stationCode : loggedInUserStation) : loggedInUserStation,
				defaultAirportCode: selectedAirportCode,
				// language: loggedInUserProfile.language
				// 	? loggedInUserProfile.language
				// 	: 'EN_US',
				notificationDetails: {
					notificationAction: notifications,
					notificationEmail: [emailAddress],
					notificationPhoneNo:
						mobContryCode && mobileNumber
							? [`${mobContryCode} ${mobileNumber}`]
							: null,
				},
				preference: preferences,
				roles: roles.length ? roles : null,
				// privilegeDetails: {
				// 	userId: userId,
				// 	userType: userTypeKey,
				// 	weightUnit: preferences.weightUnit,
				// 	dimensionUnit: preferences.dimensionUnit,
				// 	language: preferences.language,
				// 	bookingPrivilege: bookingPrevilege,
				// 	capturePrivilege: capturePrevilege,
				// 	dashBoardPrivilege: dashboardPrevilege,
				// },
			},
		}
		return requestBody
	}
	const loggedInUserProfile = getLoggedInUserProfile()

	const getNotificationSubscribeRequest = () => {
		const loggedInUserProfile = getLoggedInUserProfile()
		// const loggedInUserAirport = loggedInUserProfile && loggedInUserProfile?.defaultAirportCode ? loggedInUserProfile?.defaultAirportCode : null

		const requestBody = {
			agentCode: loggedInUserProfile?.agentCode ? loggedInUserProfile.agentCode : null,
			userId: userId,
			userType: userTypeKey,
			email: emailAddress,
			station: currUserDetails?.stationCode || null,
			status: true,
			accepted: notifications && notifications.includes('Accepted'),
			departed: notifications && notifications.includes('Departed'),
			arrived: notifications && notifications.includes('Arrived'),
			notified: notifications && notifications.includes('Notified'),
			delivered: notifications && notifications.includes('Delivered')
		}
		return requestBody
	}

	const removeError = (event) => {
		const id = event.target.id + ''
		setError((prevState) => ({ ...prevState, [id]: '' }))
	}

	const hasError = (key) => {
		if (error !== null && error[key] && error[key] !== '') {
			return true
		} else {
			return false
		}
	}

	const handleAlertClose = () => {
		setAlertMessage('')
		setCreateSuccess(false)
	}
	// const onChangeLanguage = (event) => {
	// 	setPreferences({ ...preferences, language: event.target.value })
	// }

	// useEffect(() => {
	// 	const mappedLang = i18n.language === 'zh' ? 'zh_CN' : 'en_US'
	// 	setPreferences(prev => ({ ...prev, language: mappedLang }))
	//   }, [i18n.language])

	const onChangeLanguage = (event) => {
		const selectedLang = event.target?.value || event.value
		setPreferences(prev => ({ ...prev, language: selectedLang }))

		const langCode = selectedLang === 'zh_CN' ? 'zh' : 'en'
		i18n.changeLanguage(langCode)
	}

	const onChangeWeightUnit = (event) => {
		setPreferences({ ...preferences, weightUnit: event.target.value })
	}

	const onChangeDimensionUnit = (event) => {
		setPreferences({ ...preferences, dimensionUnit: event.target.value })
	}

	const triggerPhoneCodeValidation = () => {
		validatePhoneCountryCode(phContryCode, phoneNumber, setError)
	}

	const triggerMobPhoneCodeValidation = () => {
		validateMobileCountryCode(mobContryCode, mobileNumber, setError)
	}

	const [selectedDestination] = useState(null)

	const handleDefaultAirportSetError = (fieldKey, errCode) => {
		// Suppress origin error coming from AirportAutocomplete for this field
		if (fieldKey === FORM_FIELDS.ORIGIN) {
			// Only set our airport code error after blur (see wrapper div onBlur)
			return;
		}
	};

	const setDefaultAirportError = () => {
		setError(prev => ({ ...(prev || {}), defaultAirportCode: MESSAGES.INVALID_AIRPORT_CODE }));
	};
	const clearDefaultAirportError = () => {
		setError(prev => ({ ...(prev || {}), defaultAirportCode: '' }));
	};

	const draftCallback = () => { }

	const onSelectOrigin = (airportObj) => {
		const code = airportObj?.code || ''
		setSelectedOrigin(airportObj)
		setSelectedAirportCode(code)
		resetDefaultAirportInput(code) // keep underlying input state in sync
		clearDefaultAirportError('defaultAirportCode')
		validateStationCode(code, setError, 'defaultAirportCode') // immediate validation (optional)
	}


	return (
		<div className={`create-user-panel ${isRTL ? 'rtl' : ''}`}>
			{alertMessage !== '' && (
				<Alert
					isError={!createSuccess}
					showAlert={true}
					message={t(alertMessage, { ns: 'errors' })}
					onAlertClose={handleAlertClose}
					setTimeout={true}
				/>
			)}
			{isLoading ? <LoadingIndicator /> : <></>}
			{(companyName || loggedInUserProfile?.companyName || customerCode || loggedInUserProfile?.customerCode) && (
				<div className='customer-code-container'>
					<div className='company-name'>
						<div className='company-name-value'>{companyName != null ? companyName : loggedInUserProfile?.companyName}</div>

					</div>
					<div className='customer-code'>
						<div className='form-item-label'>
							{t('COMMON.CUS_CODE')}
						</div>
						<div className='form-item-value'>
							{customerCode != null ? customerCode : loggedInUserProfile?.customerCode}
						</div>
					</div>
				</div>
			)}
			<div className='user-information-panel'>
				<span className='heading'>{t('COMMON.USER_INFO')}</span>
				{/* <div className='user-information-panel'> */}
				<div className='user-info'>
					<div className='form-row'>
						<div
							className={`form-item form-item--text mb-0 ${error && error['userId'] ? 'red-border' : ''}`}
							data-module="molecules/form-item/FormItem"
						>

							<CommonInput
								id='userId'
								type='text'
								{...bindUserId}
								className='form-item__field'
								label={t('COMMON.USER_ID')}
								maxLength='25'
								aria-invalid={hasError('userId')}
								onFocus={removeError}
								onBlur={(e) => {
									validateUserId(userId, setError)
								}}
								error={error && error['userId'] ? t(error['userId'], { ns: 'errors' }) : ''}

							/>
						</div>
						<div
							className={`form-item form-item--text mb-0 pr-0 ${error && error['firstName'] ? 'red-border' : ''}`}
							data-module="molecules/form-item/FormItem"
						>
							<CommonInput
								id='firstName'
								type='text'
								{...bindFirstName}
								label={t('COMMON.FIRST_NAME')}
								className='form-item__field'
								maxLength='20'
								aria-invalid={hasError('firstName')}
								onFocus={removeError}
								onBlur={(e) => {
									validateName(firstName, 'firstName', setError, error)
								}}
								error={error && error['firstName']
									? t(error['firstName'], { ns: 'errors' })
									: ''}
							/>
							{/* <span className='form-item__error'>
							{error && error['firstName']
								? t(error['firstName'], { ns: 'errors' })
								: ''}
						</span> */}
						</div>
						<div
							className={`form-item form-item--text mb-0 pr-0 ${error && error['lastName'] ? 'red-border' : ''}`}
							data-module="molecules/form-item/FormItem"
						>
							<CommonInput
								id='lastName'
								type='text'
								{...bindLastName}
								className='form-item__field'
								maxLength='20'
								aria-invalid={hasError('lastName')}
								onFocus={removeError}
								label={t('COMMON.LAST_NAME')}
								onBlur={(e) => {
									validateName(lastName, 'lastName', setError, error)
								}}
								error={error && error['lastName']
									? t(error['lastName'], { ns: 'errors' })
									: ''}

							/>


						</div>
					</div>

					<div className='form-row'>
						<div
							className={`form-item form-item--text email_id mb-0 ${error && error['emailAddress'] ? 'red-border' : ''}`}
							data-module="molecules/form-item/FormItem"
						>
							<CommonInput
								id='emailAddress'
								type='text'
								label={t('COMMON.EMAIL_ID')}
								{...bindEmailAddress}
								className='form-item__field '
								maxLength='100'
								aria-invalid={hasError('emailAddress')}
								onFocus={removeError}
								onBlur={(e) => {
									validateCreateUserEmailAddress(emailAddress, setError, error)
								}}
								error={error && error['emailAddress']
									? t(error['emailAddress'], { ns: 'errors' })
									: ''}
							/>
						</div>

						{/* <div
						className="col-12 col-md-6 col-lg-4 d-block d-md-none"
						data-module="molecules/form-item/FormItem"
					>
						<div className="combined-phone-input d-flex align-items-end">
							<div
								className={`country-dropdown-wrapper ${error && error['phContryCode'] ? 'red-border' : ''}`}
							>
								<CountryCodeDropdown
									id="phContryCode"
									name="phContryCode"
									countryCodes={sotedCountryCodes}
									userCountryCode={phContryCode}
									setCountryCode={onChangePhCountryCode}
									triggerCodeValidation={triggerPhoneCodeValidation}
									setError={setError}
									removeError={removeError}
								/>
								<span className="form-item__error">
									{error && error['phContryCode']
										? t(error['phContryCode'], { ns: 'errors' })
										: ''}
								</span>
							</div>

							<div className="form-group flex-grow-1 phone-input-wrapper">
								<CommonInput
									id="phoneNumber"
									type="text"
									label={t('CREATEUSER.PHONE_NO')}
									{...bindPhoneNumber}
									className="form-item__field"
									maxLength="15"
									aria-invalid={hasError('phoneNumber')}
									onFocus={removeError}
									onBlur={(e) => {
										validatePhoneNumber(
											phoneNumber,
											phContryCode,
											setError,
											error
										);
									}}
									error={
										error && error['phoneNumber']
											? t(error['phoneNumber'], { ns: 'errors' })
											: ''
									}
								/>
							</div>
						</div>
					</div> */}

						<div
							className={`form-item form-item--text ${error && error['mobileNumber'] ? 'red-border' : ''}`}
							data-module="molecules/form-item/FormItem"
						>
							<div className="combined-phone-input d-flex align-items-end">
								<div
									className={`country-dropdown-wrapper ${error && error['mobContryCode'] ? 'red-border' : ''}`}
								>
									<CountryCodeDropdown
										id="mobContryCode"
										name="mobContryCode"
										autoCompleteType="MOB_COUNTRY_CODE"
										countryCodes={sotedCountryCodes}
										userCountryCode={mobContryCode}
										setCountryCode={onChangeMobCountryCode}
										triggerCodeValidation={triggerMobPhoneCodeValidation}
										setError={setError}
										removeError={removeError}
									/>
									<span className="form-item__error">
										{error && error['mobContryCode']
											? t(error['mobContryCode'], { ns: 'errors' })
											: ''}
									</span>
								</div>

								<div className="form-group phone-input-wrapper">
									<CommonInput
										id="mobileNumber"
										type="text"
										label={t('CREATEUSER.MOBILE_NO')}
										{...bindMobileNumber}
										className="form-item__field"
										maxLength="15"
										aria-invalid={hasError('mobileNumber')}
										onFocus={removeError}
										onBlur={(e) => {
											validateMobileNumber(mobileNumber, mobContryCode, setError, error);
										}}
										error={
											error?.mobileNumber
												? t(error.mobileNumber, { ns: 'errors' })
												: ''
										}
									/>
								</div>
							</div>
						</div>

						<div className='form-item form-item--text account_type mb-0 '>
							<CommonDropDown
								value={userType}
								options={USER_TYPES}
								label={t('COMMON.ACCOUNT_TYPE')}
								onChange={(e) => onChangeUserType(e)}

							></CommonDropDown>
						</div>
					</div>
					<div className='form-row'>

						<div className='airport-codes'>
							<div
								className={`form-item form-item--text common-autocomplete mb-0 ${error && error['defaultAirportCode'] ? 'red-border' : ''}`}
								onFocus={clearDefaultAirportError}
								onBlur={() => {
									// Fire only when leaving the whole wrapper
									const code = (selectedAirportCode || '').trim();
									if (!code) {
										setDefaultAirportError();
									}
								}}
							>
								<div className='p-float-label input-wrapper'>
									<AirportAutocomplete
										inputId='defaultAirportCode'
										autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
										selectedOrigin={selectedOrigin}
										selectedDestination={selectedDestination}
										setSelectedOrigin={onSelectOrigin}
										handleSetError={handleDefaultAirportSetError}
										clearError={clearDefaultAirportError}
										draftCallback={draftCallback}
										setNotificationMessage={() => { }}
										setNotificationType={() => { }}
									/>
									<label htmlFor='defaultAirportCode'>
										{t('COMMON.AIRPORT_CODE')}
									</label>
								</div>
								<span className='form-item__error'>
									{error && error['defaultAirportCode']
										? t(error['defaultAirportCode'], { ns: 'errors' })
										: ''}
								</span>
							</div>

						</div>

					</div>
					<div className=' privileges-row user-privileges add-account pl-1'>
						<label className='form-item__label previlege_heading'>{t('UM.PRIVILEGES')}</label>
						<div className='form-row'>
							<div className='previlege_label col-12 col-md-auto'>
								<div
									className='l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='previlege0'
										checked={
											bookingPrevilege && capturePrevilege && dashboardPrevilege
											&& informaticsPrevilege && allotmentPrevilege
										}
										disabled={userTypeKey === 'KU'}
										value='previlege0'
										type='checkbox'
										name='previlege0'
										onChange={(e) => handleChangePrevilege(e)}
									/>
									<label htmlFor='previlege0' className='form-item__label'>
										{t('COMMON.ALL')}
									</label>
								</div>
							</div>
							<div className='previlege_label col-12 col-md-auto'>
								<div
									className='l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='previlege1'
										checked={bookingPrevilege}
										disabled={userTypeKey === 'KU'}
										value='previlege1'
										type='checkbox'
										name='previlege1'
										onChange={(e) => handleChangePrevilege(e)}
									/>
									<label htmlFor='previlege1' className='form-item__label'>
										{t('COMMON.BKG')}
									</label>
								</div>
							</div>
							<div className='previlege_label col-12 col-md-auto'>
								<div
									className='l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='previlege2'
										checked={capturePrevilege}
										disabled={userTypeKey === 'KU'}
										value='previlege2'
										type='checkbox'
										name='previlege2'
										onChange={(e) => handleChangePrevilege(e)}
									/>
									<label htmlFor='previlege2' className='form-item__label'>
										{t('COMMON.DATA_CAPTURE')}
									</label>
								</div>
							</div>
							<div className='previlege_label col-12 col-md-auto'>
								<div
									className='l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='previlege3'
										checked={dashboardPrevilege}
										value='previlege3'
										disabled={userTypeKey === 'KU'}
										type='checkbox'
										name='previlege3'
										// className='form-item__field'
										onChange={(e) => handleChangePrevilege(e)}
									/>
									<label htmlFor='previlege3' className='form-item__label'>
										{t('UM.DASHBOARD_DEFAULT_PRVLG')}
									</label>
								</div>
							</div>

							<div className='previlege_label col-12 col-md-auto'>
								<div
									className='l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='previlege4'
										checked={informaticsPrevilege}
										value='previlege4'
										disabled={userTypeKey === 'KU' || !dashboardPrevilege}
										type='checkbox'
										name='previlege4'
										// className='form-item__field'
										onChange={(e) => handleChangePrevilege(e)}
									/>
									<label htmlFor='previlege4' className='form-item__label'>
										{t('UM.IFOGRPCS_PRVLG')}
									</label>
								</div>
							</div>

							<div className='previlege_label col-12 col-md-auto'>
								<div
									className='l-checkbox'
									data-module='molecules/form-item/FormItem'
								>
									<input
										id='previlege5'
										checked={allotmentPrevilege}
										value='previlege5'
										disabled={userTypeKey === 'KU' || !dashboardPrevilege}
										type='checkbox'
										name='previlege5'
										onChange={(e) => handleChangePrevilege(e)}
									/>
									<label htmlFor='previlege5' className='form-item__label'>
										{t('UM.ALLOTMNT_PRVLG')}
									</label>
								</div>
							</div>

						</div>
					</div>


					{/* <div className='form-row mt-5'>
				<div
					className='col-12 col-md-4 form-item form-item--text'
					data-module='molecules/form-item/FormItem'
				>
					<label className='form-item__label'>Confirm Email Address</label>
					<input
						id='confirmEmailAddress'
						type='text'
						{...bindConfirmEmailAddress}
						className='form-item__field'
						maxLength='100'
						aria-invalid={hasError('confirmEmailAddress')}
						onFocus={removeError}
						onBlur={(e) => {
							validateEmailAddress(
								emailAddress,
								confirmEmailAddress,
								setError,
								error
							)
						}}
					/>
					<span className='form-item__error'>
						{error && error['confirmEmailAddress']
							? error['confirmEmailAddress']
							: ''}
					</span>
				</div>
			</div> */}

				</div>
			</div>
			<div className='user-information-panel'>
				<span className=' heading'>
					{t('COMMON.PREF')}
				</span>

				<div className='preferences'>
					<div className='form-row'>
						<div className='form-item form-item pl-2 mb-0'>
							<CommonDropDown
								value={preferences.language}
								options={LANGUAGES}
								label={t('COMMON.LANG')}
								onChange={onChangeLanguage}
								disabled={!MULTILANGUAGE_SUPPORT_ENABLED}
								itemTemplate={(option) => t(option.label)}
								valueTemplate={(option) => t(option?.label || '')}
							></CommonDropDown>
						</div>
					</div>
					<div className='form-row '>
						<div className='custom-m-0 form-item pl-2'>
							<CommonDropDown
								value={preferences.weightUnit}
								options={WEIGHT_UNIT_SELECT_ITEMS}
								label={t('COMMON.WT')}
								onChange={onChangeWeightUnit}
							></CommonDropDown>
						</div>
						<div className='custom-m-0 form-item pl-2'>
							<CommonDropDown
								value={preferences.dimensionUnit}
								options={DIMENSION_UNIT_SELECT_ITEMS}
								label={t('COMMON.DIM')}
								onChange={onChangeDimensionUnit}
							></CommonDropDown>
						</div>
					</div>
				</div>
			</div>
			<div className='user-information-panel'>
				<span className='heading'>
					{t('COMMON.NOTIFICATION')}
				</span>
				<div className='notifications-info'>
					<div className=' form-row notify_list'>
						<div className='col-12 col-md-auto'>
							<div
								className='l-checkbox'
								data-module='molecules/form-item/FormItem'
							>
								<input
									id='milestone1'
									checked={milestones.milestone1}
									value='All'
									type='checkbox'
									name='milestone1'
									onChange={handleChangeMilestone}
								/>
								<label htmlFor='milestone1' className='form-item__label'>
									{t('COMMON.ALL')}
								</label>
							</div>
						</div>
						<div className='col-12 col-md-auto'>
							<div
								className='l-checkbox'
								data-module='molecules/form-item/FormItem'
							>
								<input
									id='milestone3'
									checked={milestones.milestone3}
									value='Departed'
									type='checkbox'
									name='milestone3'
									onChange={handleChangeMilestone}
								/>
								<label htmlFor='milestone3' className='form-item__label'>
									{t('COMMON.DEPARTED')}
								</label>
							</div>
						</div>
						<div className='col-12 col-md-auto'>
							<div
								className='l-checkbox'
								data-module='molecules/form-item/FormItem'
							>
								<input
									id='milestone5'
									checked={milestones.milestone5}
									value='Notified'
									type='checkbox'
									name='milestone5'
									onChange={handleChangeMilestone}
								/>
								<label htmlFor='milestone5' className='form-item__label'>
									{t('COMMON.NOTIFIED')}
								</label>
							</div>
						</div>
						<div className='col-12 col-md-auto'>
							<div
								className='l-checkbox'
								data-module='molecules/form-item/FormItem'
							>
								<input
									id='milestone2'
									checked={milestones.milestone2}
									value='Accepted'
									type='checkbox'
									name='milestone2'
									onChange={handleChangeMilestone}
								/>
								<label htmlFor='milestone2' className='form-item__label'>
									{t('COMMON.ACCEPTED')}
								</label>
							</div>
						</div>

						<div className='col-12 col-md-auto'>
							<div
								className='l-checkbox'
								data-module='molecules/form-item/FormItem'
							>
								<input
									id='milestone4'
									checked={milestones.milestone4}
									value='Arrived'
									type='checkbox'
									name='milestone4'
									onChange={handleChangeMilestone}
								/>
								<label htmlFor='milestone4' className='form-item__label'>
									{t('COMMON.ARRIVED')}
								</label>
							</div>
						</div>

						<div className='col-12 col-md-auto'>
							<div
								className='l-checkbox'
								data-module='molecules/form-item/FormItem'
							>
								<input
									id='milestone6'
									checked={milestones.milestone6}
									value='Delivered'
									type='checkbox'
									name='milestone6'
									onChange={handleChangeMilestone}
								/>
								<label htmlFor='milestone6' className='form-item__label'>
									{t('COMMON.DELIVERED')}
								</label>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div className='form-row'>
				<div className='cta_wrap ml-1 col-12'>
					<PrimaryButton
						className="primary-button"
						onClick={handleSubmit}
						label={t('COMMON.SAVE')}
					/>

					<SecondaryButton
						className="button_cancel custom-ml-4"
						onClick={() => setAddUser(false)}
						label={t('COMMON.CANCEL')}
					/>


				</div>
			</div>
		</div>

	)
}
const mapStateToProps = ({ searchForm, loadingDetails }) => ({
	searchFormData: searchForm.searchFormData,
	loadingDetails: loadingDetails,
})
const mapDispatchToProps = (dispatch, message) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(CreateUserForm)